"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepsContainer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("../StepCard.css");

var _styles = {
  "card": "StepCard__card___LI0aC",
  "title": "StepCard__title___3IZi8",
  "date": "StepCard__date___1q_HB",
  "chip-tag": "StepCard__chip-tag___393Mz",
  "step": "StepCard__step___1MmRI",
  "active": "StepCard__active___2Jj5i",
  "step-title": "StepCard__step-title___1qMha",
  "show-steps": "StepCard__show-steps___3lBjm",
  "show-hide-steps": "StepCard__show-hide-steps___2ThPx"
};

const styles = _bind.default.bind(_styles);

const StepsContainer = (0, _mobxReact.observer)(({
  className,
  children,
  activeStep,
  dataTestId,
  complete = false,
  completedContent,
  color
}) => {
  const [showPrevSteps, setShowPrevSteps] = (0, _react.useState)(false);
  const prevSteps = complete ? [...children] : [...children].slice(0, activeStep - 1);
  const hasPrevSteps = prevSteps.length;
  const composed_classname = (0, _bind.default)(styles('steps-container', className));
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: composed_classname,
    "data-testid": dataTestId
  }, !!hasPrevSteps && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_.Expandable, {
    expand: showPrevSteps
  }, _react.Children.map(prevSteps, (child, index) => {
    return _react.default.createElement(_react.Fragment, {
      key: index
    }, child);
  })), _react.default.createElement(_.Flex, {
    className: styles('show-steps'),
    padding: [8, 0],
    justifyContent: 'center'
  }, showPrevSteps ? _react.default.createElement("div", {
    "data-testid": `${dataTestId}-hide-completed-step`,
    className: styles('show-hide-steps'),
    onClick: () => setShowPrevSteps(!showPrevSteps)
  }, _react.default.createElement(_.Text, {
    color: color !== null && color !== void 0 ? color : _.Color.neutral._90,
    text: _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_.Icon, {
      name: _.IconEnum.circle_minus,
      color: color !== null && color !== void 0 ? color : _.Color.neutral._80,
      size: 16
    }), `Hide completed step${hasPrevSteps > 1 ? 's' : ''}`)
  })) : _react.default.createElement("div", {
    "data-testid": `${dataTestId}-show-completed-step`,
    className: styles('show-hide-steps'),
    onClick: () => setShowPrevSteps(!showPrevSteps)
  }, _react.default.createElement(_.Text, {
    color: color !== null && color !== void 0 ? color : _.Color.neutral._90,
    text: _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_.Icon, {
      name: _.IconEnum.circle_plus,
      color: color !== null && color !== void 0 ? color : _.Color.neutral._80,
      size: 16
    }), `Show completed step${hasPrevSteps > 1 ? 's' : ''}`)
  })))), complete ? _react.default.createElement("div", null, completedContent) : _react.Children.map(children, (child, index) => {
    if (activeStep > index + 1) {
      return;
    }

    return _react.default.createElement(_react.Fragment, {
      key: index
    }, child);
  })));
});
exports.StepsContainer = StepsContainer;